import { render, staticRenderFns } from "./NumberPoolsList.vue?vue&type=template&id=1289ebd4"
import script from "./NumberPoolsList.vue?vue&type=script&lang=js"
export * from "./NumberPoolsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports